import { takeEvery, put, select } from 'redux-saga/effects'
import { MINWAGE_GET_WAGES_BY_JURISDICTION } from './actionTypes'
import { api } from '../common/helpers'
import { setWagesByJurisdiction } from './actions'

function* getWagesByJurisdictionData() {
  const companySettings = yield select((state) => {
    return (state.account && state.account.company && state.account.company) || {}
  })
  const apiResponse = yield api({
    api: 'wages',
    params: {
      companySize: companySettings.employeeCount,
      annualRevenue: companySettings.annualRevenue,
      industry: companySettings.industry ? companySettings.industry.name : null,
      subIndustry: companySettings.industry && companySettings.industry.subIndustry ? companySettings.industry.subIndustry.name : null,
      subSubIndustry: companySettings.industry && companySettings.industry.subIndustry && companySettings.industry.subIndustry.subIndustry ? companySettings.industry.subIndustry.subIndustry.name : null
    }
  })

  if (!apiResponse.error) {
    yield put(setWagesByJurisdiction(apiResponse.data))
  }
}

export default function* minWageSaga() {
  yield takeEvery(MINWAGE_GET_WAGES_BY_JURISDICTION, getWagesByJurisdictionData)
}
